var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('post-form',{attrs:{"category-id":_vm.categoryId,"sub-category-id":_vm.subCategoryId,"category-url":_vm.categoryUrl,"sub-category-url":_vm.subCategoryUrl,"post-prop":_vm.post,"title":'Edition post ' + _vm.post.title,"is-editing":""},on:{"post-form-submitted":_vm.submitPost}},[(_vm.loading)?_c('LoaderBox'):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab3fb1b6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/component/Post/PostEdit.vue
// module id = KtTb
// module chunks = 0